import { BUILDER_DOCUMENT_TYPE } from 'hb-react/backoffice/types/builder/builderDocument';

export const shouldDisplayTextComponentAsParagraph = (
  builderType?: BUILDER_DOCUMENT_TYPE,
) => builderType === BUILDER_DOCUMENT_TYPE.PAGE;
